import { render, staticRenderFns } from "./salesmanDetail.vue?vue&type=template&id=5b88286e&scoped=true"
import script from "./salesmanDetail.vue?vue&type=script&lang=js"
export * from "./salesmanDetail.vue?vue&type=script&lang=js"
import style0 from "./salesmanDetail.vue?vue&type=style&index=0&id=5b88286e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b88286e",
  null
  
)

export default component.exports